import { useState, useEffect } from 'react';

/**
 * Detecta si el dispositivo es móvil usando dos señales:
 * 1. Ancho de pantalla (matchMedia) — se actualiza si el usuario rota el dispositivo
 * 2. User-Agent — para detección por tipo de hardware (tablet, phone)
 *
 * Retorna `true` cuando el ancho < 768px O el UA indica mobile.
 */
export function useIsMobile(breakpoint = 768) {
  const getMatch = () => {
    const narrowScreen = window.matchMedia(`(max-width: ${breakpoint - 1}px)`).matches;
    const mobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return narrowScreen || mobileUA;
  };

  const [isMobile, setIsMobile] = useState(getMatch);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const handler = () => setIsMobile(getMatch());
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [breakpoint]); // eslint-disable-line

  return isMobile;
}
